import * as React from "react";
import { observer } from "mobx-react";
import { UitkCheckbox } from "uitk-react-switch";
import { HotelWizardStateProps } from "components/flexComponents/WizardHotelPWAv2/typings";
import { FlexClickTracker } from "src/components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { UitkText } from "uitk-react-text";
const CheckboxTracked = FlexClickTracker(UitkCheckbox);

export interface HotelAddFlightCheckboxProps extends HotelWizardStateProps {
  packageRatesTermsUrl?: string;
  percentSave?: number;
  isChecked?: boolean;
}

export const HotelPackageRatesTermsCheckbox = observer(
  ({ hotelWizardState, isChecked }: HotelAddFlightCheckboxProps) => {
    const urlParameterName = "packageRates";

    const handleChange = () => {
      hotelWizardState.togglePackageRatesTermsCheckbox();
    };

    return (
      <div>
        <UitkText size={300} weight="bold" spacing="six">
          {hotelWizardState.travelAgentPackageRatesDetail.heading}
        </UitkText>
        <CheckboxTracked
          data-stid="taap-package-rates"
          id={urlParameterName}
          data-testid={urlParameterName}
          checked={!!isChecked}
          onChange={handleChange}
          moduleName="WizardHotelPWAv2"
          rfrr="TermsConditions_PackageRates"
          value={!!isChecked && "true"}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: hotelWizardState.travelAgentPackageRatesDetail.termsAndConditions,
            }}
          />
        </CheckboxTracked>
      </div>
    );
  }
);
